import { render, staticRenderFns } from "./SkillGamesPage.vue?vue&type=template&id=02bb3777&scoped=true&"
import script from "./SkillGamesPage.vue?vue&type=script&lang=js&"
export * from "./SkillGamesPage.vue?vue&type=script&lang=js&"
import style0 from "./SkillGamesPage.vue?vue&type=style&index=0&id=02bb3777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb3777",
  null
  
)

export default component.exports